"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MobileList = exports.BeautyLink = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'start',
  flexWrap: 'wrap',
  margin: theme.spacing(0),
  a: {
    width: '160px',
    flex: '0 0 160px'
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: 1110,
    gap: theme.spacing(6),
    margin: theme.spacing(6, 12)
  }
}));
const BeautyLink = exports.BeautyLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  fontSize: '1.7rem',
  textDecoration: 'none',
  flex: 1,
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    display: 'block',
    lineHeight: '2.1rem',
    textDecoration: 'none'
  },
  '&:hover, &:focus, &:active': {
    color: theme.palette.secondary.main,
    WebkitTapHighlightColor: 'transparent'
  }
}));
const MobileList = exports.MobileList = (0, _mui.styled)('ul')(({
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  listStyleType: 'none',
  li: {
    padding: theme.spacing(2, 3, 2, 10)
  }
}));